import React, { useEffect } from 'react';
import { FixedWrapper } from 'features/UserDeposits/Components/Success';

const Error = () => {
    useEffect(() => {
        let message = JSON.stringify({
            type: 'custom-event',
            status: 'error',
            url: window.location.href,
        });

        window.parent.postMessage(message, '*');
    }, []);

    return <FixedWrapper />;
};

export default Error;
